import { CONFIG_INIT } from '../app/app.config.actions';

const initialState = {};

export default (state = initialState, action) => {
  switch (action && action.type) {
    case CONFIG_INIT: {
      return {
        ...state,
        ...action.config.featureFlipping,
      };
    }
    default: {
      return state;
    }
  }
};
